import React, { Component } from "react";

import "./Drawer.component.scss";

export interface DrawerProps {
    title: string;
    onClose: any;
}

export interface DrawerState {
    open: boolean;
}

export default class Drawer extends Component<DrawerProps, DrawerState> {
    constructor(props) {
        super(props);
        this.state = {
            open: true
        };
    }

    toggleDrawer = () => {
        this.setState({
            open: !this.state.open
        });
    };

    render() {
        return (
            <div className="drawer-container container">
                <div className={`drawer ${this.state.open ? "open" : ""}`}>
                    <div className="drawer-header">
                        <p onClick={this.toggleDrawer}>{this.props.title}</p>
                        <button onClick={this.toggleDrawer}>
                            <i className="icon-minus-light"></i>
                        </button>
                        <button onClick={this.props.onClose}>
                            <i className="icon-times-light"></i>
                        </button>
                    </div>
                    <div className="drawer-body">{this.props.children}</div>
                </div>
            </div>
        );
    }
}
